import React from 'react'
import { FormattedMessage } from 'react-intl'
import { CellCompProps } from '../Table'

const FormattedCell = <T extends {}> ({ row, col }: CellCompProps<T>) => {
  const val = row[col.name]
  return (
    <div title={val} className={`cell ${col.name}`}>
      <FormattedMessage id={`formatted-cell.${val}`} />
    </div>
  )
}

export default FormattedCell
